import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import classnames from 'classnames';

import {ActionMenu} from '../action-menu/action-menu';
import type {SelectMenuOption} from '../action-menu/action-menu';
import {Button} from '../button/button';
import {Link} from '../link/link';
import {StatusBadge} from '../status-badge/status-badge';
import type {Level} from '../status-badge/status-badge';

import styles from './actionable-header.module.css';

// This type needs to remain a subset of StatusBadgeProps
export type ActionableHeaderStatusBadgeProps = {
    text: string;
    level: Level;
    customIcon?: React.ComponentType<any>;
};

type Props = {
    isArchived?: boolean;
    name: string;
    to: string;
    metadataPrimary?: string | React.ReactNode | null | undefined;
    metadataSecondary?: string | React.ReactNode | null | undefined;
    status?: ActionableHeaderStatusBadgeProps;
    secondaryLink?: {
        text: string;
        onClick: () => void;
    };
    options?: SelectMenuOption[];
    getActionMenuRef?: (arg1?: HTMLElement | null | undefined) => void;
    noPadding?: boolean;
};

export function ActionableHeader(props: Props) {
    const status = props.isArchived
        ? {text: 'Archived', level: 'hidden', customIcon: undefined}
        : props.status;

    return (
        <div
            className={
                props.noPadding
                    ? styles['actionable-header--no-padding']
                    : styles['actionable-header']
            }
        >
            <div className={styles['header-group']}>
                {props.isArchived ? (
                    <div className={styles['name--archived']}>{props.name}</div>
                ) : (
                    // @ts-expect-error
                    <Link as={RoutedLink} variant='primary' size='big' to={props.to}>
                        {props.name}
                    </Link>
                )}
                <div className={styles.divider} />
                {status ? (
                    <StatusBadge
                        text={status.text}
                        // @ts-expect-error
                        level={status.level}
                        customIcon={status.customIcon}
                    />
                ) : undefined}
                <div className={styles.metadata}>{props.metadataPrimary}</div>
                {props.metadataPrimary && props.metadataSecondary ? (
                    <div className={styles['small-spacer']}>•</div>
                ) : undefined}
                <div className={styles.metadata}>{props.metadataSecondary}</div>
            </div>
            <div className={styles['header-group']}>
                {props.secondaryLink ? (
                    <Button variant='text-primary' size='big' onClick={props.secondaryLink.onClick}>
                        {props.secondaryLink.text}
                    </Button>
                ) : undefined}
                {props.secondaryLink && props.options && props.options.length ? (
                    <div className={classnames(styles.divider, styles.second)} />
                ) : undefined}
                <div className={styles['action-menu']}>
                    {props.options && props.options.length ? (
                        <ActionMenu options={props.options} getRef={props.getActionMenuRef} />
                    ) : undefined}
                </div>
            </div>
        </div>
    );
}
